// Firebase notification handler for your Vue app
import UserService from './user.service';

// Simple notification service that works with your existing setup
export default {
  async requestPermission() {
    try {
      const permission = await Notification.requestPermission();
      
      if (permission === 'granted') {
        console.log('Notification permission granted.');
        
        // For now, we'll use a simple token or user-based system
        // You can enhance this later with actual FCM tokens
        const userToken = this.generateUserToken();
        await this.sendTokenToServer(userToken);
        return userToken;
      } else {
        console.log('Unable to get permission to notify.');
        return null;
      }
    } catch (err) {
      console.log('An error occurred while retrieving token: ', err);
      return null;
    }
  },

  generateUserToken() {
    // Generate a simple token based on user session
    return `user_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  },

  async sendTokenToServer(token) {
    try {
      await UserService.authPostRequest('update-fcm-token', { fcm_token: token });
      console.log('FCM token sent to server successfully');
    } catch (error) {
      console.error('Error sending FCM token to server:', error);
    }
  },

  setupForegroundMessageListener() {
      // Simple polling for new notifications
      setInterval(async () => {
          try {
              const response = await UserService.authGetRequest('notifications/user');
              if (response.data.status === 'success') {
                  const notifications = response.data.data.notifications;
                  // Check for new unread notifications
                  this.checkForNewNotifications(notifications);
              }
          } catch (error) {
              console.error('Error checking for new notifications:', error);
          }
      }, 30000); // Check every 30 seconds
  },

  checkForNewNotifications(notifications) {
    const unreadNotifications = notifications.filter(n => !n.read_at);
    const lastChecked = localStorage.getItem('lastNotificationCheck');
    const currentTime = new Date().getTime();
    
    if (lastChecked) {
      const newNotifications = unreadNotifications.filter(n => 
        new Date(n.created_at).getTime() > parseInt(lastChecked)
      );
      
      if (newNotifications.length > 0) {
        // Show notifications for new ones
        newNotifications.forEach(notification => {
          this.showCustomNotification({
            notification: {
              title: notification.data.title,
              body: notification.data.description
            },
            data: notification.data
          });
        });
      }
    }
    
    localStorage.setItem('lastNotificationCheck', currentTime.toString());
  },

  showCustomNotification(payload) {
    // Create custom in-app notification
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: '/assets/icons/icon-192x192.png',
        badge: '/assets/icons/badge.png',
        tag: 'wisdom-guide-notification'
      });

      // Handle notification click
      notification.onclick = function() {
        window.focus();
        if (payload.data.link) {
          window.location.href = `/#${payload.data.link}`;
        } else {
          window.location.href = '/#/notifications';
        }
        notification.close();
      };

      // Auto close after 5 seconds
      setTimeout(() => {
        notification.close();
      }, 5000);
    }
  },

  // Method to manually trigger a test notification
  async testNotification() {
    const testPayload = {
      notification: {
        title: 'Test Notification',
        body: 'This is a test notification from Wisdom Guide!'
      },
      data: {
        link: '/notifications'
      }
    };
    
    this.showCustomNotification(testPayload);
  }
};